import LanguageDetector from 'i18next-browser-languagedetector';
import { LOCALSTORAGE_KEYS } from '@constants';

export default new LanguageDetector(null, {
  caches: ['localStorage'],
  lookupLocalStorage: LOCALSTORAGE_KEYS.LANGUAGE,
});
